export const HOST = process.env.REACT_APP_API
export const HOME_PATH = '/'

export const LOGIN = `${HOST}/login/`
export const USER_AUTH = `${HOST}/api/v1/claims/users/auth/`
export const TASK_GRAPHS = `${HOST}/internal/v3/task-graphs/`
export const GRAPH = `${HOST}/api/v1/graphs/tree/`
export const GRAPH_UPDATE = `${HOST}/api/v1/graphs/tree/`
